import { IonContent, IonPage, IonRouterOutlet, isPlatform } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import { Capacitor } from "@capacitor/core";
import { FooterAuth } from "../../components/NavBarAuth";
import styles from "./styles.module.css";
import { useAppStore } from "../../store/app";

const isMobile = isPlatform("android") || isPlatform("ios");
const isNative = Capacitor.isNativePlatform();
type AuthLayoutProps = {
  children: React.ReactNode;
};

export default function AuthLayout({ children }: AuthLayoutProps) {
  const user = useAppStore((state) => state.user);
  const { language } = user;
  const setLanguage = useAppStore((state) => state.setLanguage);

  const switchLanguage = async (language: string) => {
    setLanguage(language);
  };

  return (
    <IonPage id="main-content">
      <IonContent className="ion-padding">
        <div className={styles.authWrapper}>
          <div className={styles.leftContent}>
            <div className="logo-white mr-auto" />
            <div className="flex flex-column w-100 gap-1">
              <h1 className="color-step-50 fs-7 fw-bold">
                <FormattedMessage id="auth.title" />
              </h1>
              <h2 className="color-step-100 fs-4 mb-0">
                <FormattedMessage id="auth.description" />
              </h2>
            </div>
            <FooterAuth
              hide={isPlatform("android") || isPlatform("ios")}
              switchLanguage={switchLanguage}
              language={language}
            />
          </div>
          <div className={styles.rightContent}>
            <div className="logo-white mobile mx-auto d-block d-md-none" />
            <div
              className={styles.formContainer}
              {...(isMobile || isNative
                ? { style: { paddingBottom: isNative ? "1.5rem" : "6rem" } }
                : {})}
            >
              {children}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
